export enum ActionTypes {
  CLEAR_IMPORT_GEOFENCES = 'CLEAR_IMPORT_GEOFENCES',
  DELETE_GEOFENCE_REQUEST = 'DELETE_GEOFENCE_REQUEST',
  DELETE_GEOFENCE_SUCCEEDED = 'DELETE_GEOFENCE_SUCCEEDED',
  EDIT_GEOFENCE_REQUEST = 'EDIT_GEOFENCE_REQUEST',
  IMPORT_GEOFENCES_FAILED = 'IMPORT_GEOFENCES_FAILED',
  IMPORT_GEOFENCES_REQUEST = 'IMPORT_GEOFENCES_REQUEST',
  IMPORT_GEOFENCES_SUCCEEDED = 'IMPORT_GEOFENCES_SUCCEEDED',
  LOAD_GEOFENCES_FAILED = 'LOAD_GEOFENCES_FAILED',
  LOAD_GEOFENCES_REQUEST = 'LOAD_GEOFENCES_REQUEST',
  LOAD_GEOFENCES_SUCCEEDED = 'LOAD_GEOFENCES_SUCCEEDED',
  SAVE_GEOFENCE_REQUEST = 'SAVE_GEOFENCE_REQUEST',
  SAVE_GEOFENCE_SUCCEEDED = 'SAVE_GEOFENCE_SUCCEEDED',
  VALIDATE_GEOFENCES_FAILED = 'VALIDATE_GEOFENCES_FAILED',
  VALIDATE_GEOFENCES_REQUEST = 'VALIDATE_GEOFENCES_REQUEST',
  VALIDATE_GEOFENCES_SUCCEEDED = 'VALIDATE_GEOFENCES_SUCCEEDED',
}
